import React, { useState, useEffect } from 'react';
const API = process.env.REACT_APP_API_URL || 'https://lacasadelpuro-pos-production.up.railway.app';
const GOLD = '#C9A84C'; const BORDER = '#2A2A2A'; const TEXT = '#E8E0D0';

export default function History({ staff, hideHeader }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const data = await fetch(API + '/tabs/history').then(r => r.json());
      setTransactions(Array.isArray(data) ? data : []);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const filtered = transactions.filter(t =>
    !search || (t.member_name||'').toLowerCase().includes(search.toLowerCase()) ||
    (t.tab_name||'').toLowerCase().includes(search.toLowerCase()) ||
    String(t.id).includes(search)
  );

  return (
    <div style={{ padding: 20, color: TEXT, fontFamily: 'Georgia' }}>
      {!hideHeader && <h1 style={{ color: GOLD, marginBottom: 20, fontSize: 22, fontWeight: 400 }}>Transaction History</h1>}
      <div style={{ position: 'relative', marginBottom: 16 }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by member, tab name, or ID..."
          style={{ width: '100%', background: '#111', border: `1px solid ${BORDER}`, borderRadius: 8, padding: '10px 40px 10px 14px', color: TEXT, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
        {search && (
          <button
            type="button"
            onClick={() => setSearch('')}
            aria-label="Clear search"
            style={{
              position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
              width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'transparent', border: 'none', borderRadius: 6,
              color: '#C9A84C', fontSize: 20, lineHeight: 1, cursor: 'pointer', padding: 0,
            }}
          >×</button>
        )}
      </div>
      {loading ? <div style={{ color: '#888', textAlign: 'center', padding: 40 }}>Loading...</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['ID','Tab','Member','Total','Tax','Method','Closed'].map(h => (
              <th key={h} style={{ textAlign: 'left', padding: '10px 12px', borderBottom: `1px solid ${BORDER}`, color: '#888', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase' }}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {filtered.map(t => (
              <tr key={t.id}>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13, color: '#888' }}>#{t.id}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13 }}>{t.tab_name || `Tab ${t.id}`}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13, color: t.member_name ? GOLD : '#555' }}>{t.member_name || 'Walk-in'}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13, color: GOLD }}>${parseFloat(t.total||0).toFixed(2)}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13, color: '#888' }}>${parseFloat(t.tax||0).toFixed(2)}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 13 }}>{t.payment_method || '—'}</td>
                <td style={{ padding: '10px 12px', borderBottom: '1px solid #1E1E1E', fontSize: 12, color: '#666' }}>{t.closed_at ? new Date(t.closed_at).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#444' }}>No transactions found</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
